<script>
	import { api } from "./../libs/api.js";

	import { Link, navigate } from 'svelte-routing';
	import { _ } from 'svelte-i18n';

	import BaseLayer from "./../components/BaseLayer.svelte";

	let loading = false;
	let bad_credentials = false;

	async function handle_login(event) {
		loading = true;
		let form = event.target.parentElement;
		let email = form['email'].value;
		let password = form['password'].value;

		try {
			await api.login(email, password);
			navigate("/", { replace: true });
		}
		catch(e) {
			console.log(e)
			bad_credentials = true;
		} finally {
			loading = false;
		}
	}
</script>

<BaseLayer bg="green">
	<div class="bg-base-100 mx-16 mt-32 p-4">
		<h3 class="page-title text-center uppercase"> {$_('login.login')} </h3>

		<form class="flex flex-col">
			<input name="email" type="text" placeholder="E-mail" class="bg-gray-300 text-lg w-full font-serif px-4 py-2 mt-6 placeholder:text-white" />
			<input name="password" type="password" placeholder="Password" class="bg-gray-300 text-lg w-full font-serif px-4 py-2 mt-6 placeholder:text-white" />
			<button class:loading class="btn btn-lg font-lg btn-accent mt-10" on:click|preventDefault={handle_login}> {$_('login.enter')} </button>
		</form>
	</div>

	{#if bad_credentials}
	<div class="mx-4 mt-16">
		<div class="alert alert-error shadow-lg">
		  <div>
		    <svg xmlns="http://www.w3.org/2000/svg" class="stroke-current flex-shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
		    <span> {$_('login.invalid_credentials')} </span>
		  </div>
		</div>
	</div>
	{/if}
</BaseLayer>

